<div class="flex flex-col border-b border-gray-1 min-h-[76.5px]">
  @if (isLoading() || isSaving()) {
    <div class="w-full relative">
      <div class="w-full absolute">
        <mat-progress-bar
          class="mds-x-small"
          data-cy="3d-list-loader"
          [mode]="'indeterminate'"
        ></mat-progress-bar>
      </div>
    </div>
  }

  @if (showTextFilter()) {
    <div class="pt-1 px-3">
      <modus-form-field>
        <md-icon modus-icon-prefix>search</md-icon>
        <button modus-icon-suffix data-cy="3d-clear-search-button" (click)="hideTextFilterClick()">
          <md-icon>close</md-icon>
        </button>
        <input
          auto-focus
          #textFilter
          modus-input
          data-cy="3d-search-field"
          [formControl]="textFilterControl"
          placeholder="{{ translations.searchPlaceholder.text }}"
          size="large"
        />
      </modus-form-field>
    </div>
  } @else {
    <div class="flex">
      <div class="flex flex-col flex-grow pl-3 pt-3 pr-2 text-xl font-medium overflow-hidden">
        <div class="overflow-hidden whitespace-nowrap text-ellipsis">Reality Capture</div>
        <div class="w-[154px] max-w-full">
          <mat-select
            id="3d-list-filter"
            class="modus-dropdown"
            panelClass="modus-dropdown-panel fit-content"
            data-cy="3d-list-filter"
            [formControl]="filterOptionControl"
            disableRipple
          >
            <mat-option [value]="scan3dListFilterOption.ShowAll">{{
              translations.filterOptions.allData.text
            }}</mat-option>
            <mat-option [value]="scan3dListFilterOption.ShowSelected">{{
              translations.filterOptions.selectedOnly.text
            }}</mat-option>
          </mat-select>
        </div>
      </div>

      <div class="flex items-center mr-1">
        <sd-scandata-sort-menu
          [sortInfo]="sortInfo()"
          (onSortClick)="sortClick($event)"
        ></sd-scandata-sort-menu>
        <button
          id="3d-search"
          class="text-gray-8"
          modus-icon-button
          (click)="showTextFilterClick()"
        >
          <md-icon>search</md-icon>
        </button>
        <button
          id="3d-global-settings"
          class="text-gray-8"
          modus-icon-button
          (click)="onSettingClick()"
        >
          <md-icon>settings</md-icon>
        </button>
      </div>
    </div>
  }
</div>

<div class="relative">
  @if (hasCurrentStation()) {
    <div
      class="flex flex-row items-center pl-3 border-b border-gray-1 bg-blue-light text-white"
      data-cy="current-station-toolbar"
    >
      <div
        modus-tooltip="{{ currentStationTooltip() }}"
        tooltipClass="break-anywhere !whitespace-pre-wrap"
        class="w-full overflow-hidden text-ellipsis whitespace-nowrap mr-1"
      >
        {{ currentStationLabel() }}
      </div>
      <div class="flex justify-end mr-2">
        <button
          id="3d-exit-station"
          modus-tooltip="{{ translations.station.exit.text }}"
          class="bg-blue-light text-white enabled:hover:text-white"
          modus-icon-button
          (click)="onExitStationClick()"
        >
          <md-icon>close</md-icon>
        </button>
      </div>
    </div>
  }

  @if (showClipboxBanner()) {
    <div
      class="flex flex-row items-center gap-2 pl-3 pr-2 py-1 border-b border-gray-1 bg-gray-0"
      data-cy="clipbox-banner"
    >
      <span class="text-sm text-trimble-gray flex-1 truncate">
        {{ translations.clipboxBanner.label.text }}
      </span>
      <button
        id="3d-clipbox-banner-action"
        data-cy="clipbox-banner-action"
        modus-flat-button
        color="primary"
        size="small"
        (click)="onClipAndSaveClick()"
      >
        {{ translations.clipboxBanner.action.text }}
      </button>
    </div>
  }

  @if (scanLoadError()) {
    <div class="p-4">
      <modus-alert
        class="w-full"
        message="{{ translations.scanLoadError.text }}"
        type="error"
      ></modus-alert>
    </div>
  }

  <div class="pb-3 overflow-y-auto pt-1" cdkScrollable data-cy="3d-list-scrollable">
    @if (isSaving()) {
      <div class="absolute inset-0 bg-gray-1 opacity-30 z-10"></div>
    }

    <sd-scandata-tree-view
      [scandata]="data()"
      [quotaExceeded]="quotaExceeded()"
      [hasRotatePanoramasFeature]="hasRotatePanoramasFeature()"
      [hasViewInNumarkFeature]="hasViewInNumarkFeature()"
      (modelDetailClick)="onModelDetailClick($event)"
    ></sd-scandata-tree-view>

    @if (showScandataEmpty()) {
      <sd-scandata-empty [reason]="scandataEmptyReason()"></sd-scandata-empty>
    }
  </div>
</div>
